// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__3hNLL","vLegacy":"SelectSecondary_vLegacy__2d4Za","error":"SelectSecondary_error__1s1n2","disabled":"SelectSecondary_disabled__1V6JI"};